<template>
    <USelectMenu
        v-model="modelValue"
        v-model:search-term="searchTerm"
        :items="vatPickerOptions"
        size="sm"
        class="w-full"
        :ui="{ content: 'min-w-fit ' + theme}"
        ignore-filter
    >
        <template #default>
            <span class="whitespace-nowrap">
                <span>{{ formatPercentage(modelValue.displayedRate) }}</span>
                <span class="ml-1 text-muted">%</span>
            </span>
        </template>
        <template #trailing/>
        <template #item="{item}">
            <div class="flex">
                <div class="w-6 font-semibold">{{ item.code }}</div>
                <span class="w-12">{{ formatPercentage(item.displayedRate) }}
                    <span class="text-muted">%</span>
                </span>
                <span class="text-muted ml-4">{{ cachedT('vat-codes.' + item.code) }}</span>
            </div>
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import {VatOption} from '@/vat/types/VatOptions'
import {useVatService} from '@/vat/vat.service'
import _ from 'lodash'
import {computed, ref} from 'vue'
import {useCachedT} from '@/services/useCachedI18n'

const {cachedT} = useCachedT()

const searchTerm = ref('')

const modelValue = defineModel<VatOption>('modelValue', {required: true})
defineProps({
    theme: {type: String, default: ''}
})

const {vatOptions} = useVatService()

const allowedSalesCodes = [3,31,32,33,5,51,52,6,7]

const vatPickerOptions = computed<VatOption[]>(() => {
    return _(vatOptions.value)
        .filter(vatOption => allowedSalesCodes.includes(vatOption.code))
        .reject(vatOption => !!vatOption.specificationKey)
        .filter(option => {
            if (!searchTerm.value) return true
            const lowerSearch = searchTerm.value.toLowerCase()
            return option.code.toString().toLowerCase().includes(lowerSearch) ||
                cachedT('vat-codes.' + option.code).toLowerCase().includes(lowerSearch)
        })
        .sortBy(option => option.code.toString())
        .value()
})

const formatPercentage = (fraction: number) => {
    return new Intl.NumberFormat('no', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(fraction * 100)
}

</script>

<style scoped>

</style>